import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doDelete, doPut, doPutFiles } from './utils'

// const API_ROOT = 'http://localhost:9014/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting/asset-request`

export const getAssetRequestManagementDetail = (
  id,
  pageNumber = 0,
  pageSize = 0,
  projectVersionId
) => {
  const url = `${API_ROOT_VER}/request/manage/schema/${pageNumber}/${pageSize}?id=${id}&projectVersionId=${
    projectVersionId || ''
  }`
  return doGet(url)
}

export const getAssetRequestManagementSearchForm = (
  pageNumber = 0,
  pageSize = 0,
  id,
  projectVersionId
) => {
  const url = `${API_ROOT_VER}/request/asset/schema/${pageNumber}/${pageSize}?id=${
    id || ''
  }&projectVersionId=${projectVersionId || ''}`
  return doGet(url)
}

export const searchAssetRequestManagementSearchForm = (
  request,
  pageNumber = 0,
  pageSize = 0,
  id,
  projectVersionId
) => {
  const url = `${API_ROOT_VER}/request/asset/search/${pageNumber}/${pageSize}?id=${
    id || ''
  }&projectVersionId=${projectVersionId || ''}`
  return doPost(url, request)
}

export const savehAssetRequestManagementDetail = (request) => {
  // http://localhost:9014/api/v1/accounting/asset-request/request/save
  const url = `${API_ROOT_VER}/request/save`
  return doPost(url, request)
}

export const getReserveDocumentRequest = (id = '', projectVersionId = '') => {
  // /api/files/asset/request-for-use/form

  const url = `${API_ROOT}/files/asset/request-for-use/form?id=${id}&projectVersionId=${projectVersionId}`
  return doDownload(url)
}
